import { useContext, useEffect } from 'react';
import posthog from 'posthog-js';
import { UserContext } from '../contexts/User';
import { getAccessToken } from '../utils/accessToken';
import useLazyGetData from './useLazyGetData';
import GET_USER from '../pages/Login/getUser.query';

/**
 * Hook to automatically load user data when auth token is available
 * This ensures user context is populated on app startup
 */
const useAutoLoadUser = () => {
    const { user, setUser } = useContext(UserContext);
    const [getUserInfo] = useLazyGetData(GET_USER, null, true);

    useEffect(() => {
        const loadUserData = async () => {
            const authToken = getAccessToken();

            // Only load if we have a token but no user data
            if (authToken && !user && window.navigator.onLine) {
                try {
                    const res = await getUserInfo();

                    if (res?.data?.user) {
                        setUser(res.data.user);

                        // PostHog tracking
                        res.data.user.externalId &&
                            posthog.identify(res.data.user.externalId, { name: res.data.user.externalId });

                        res.data.user.disableTracking &&
                            !posthog.has_opted_out_capturing() &&
                            posthog.opt_out_capturing();
                    }
                } catch (err) {
                    // Handle error silently
                }
            }
        };

        loadUserData();
    }, [getUserInfo, setUser, user]); // Include all dependencies

    return { user };
};

export default useAutoLoadUser;
